import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ModalState {
	sampleModal: {
		isOpen: boolean;
	};
}

const initialState: ModalState = {
	sampleModal: {
		isOpen: false,
	},
};

const modalSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {
		openModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = true;
		},
		closeModal: (state, action: PayloadAction<keyof ModalState>) => {
			state[action.payload].isOpen = false;
		},
		openModalWithData: (state, action: PayloadAction<{ modalKey: keyof ModalState; data?: unknown }>) => {
			state[action.payload.modalKey].isOpen = true;
		},
	},
});

export const { openModal, closeModal, openModalWithData } = modalSlice.actions;
export default modalSlice.reducer;
